// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"payment-main_clearfix_2ZTeM"};